(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["daily-offer-countdown"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = "[data-zl-daily-countdown]";
    const formatter = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Europe/Berlin",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hourCycle: "h23"
    });

    const pad = (value) => String(value).padStart(2, "0");

    const update = (countdown) => {
      const parts = Object.fromEntries(
        formatter.formatToParts(new Date()).map((part) => [part.type, part.value])
      );
      const elapsed = (Number(parts.hour) % 24) * 3600 + Number(parts.minute) * 60 + Number(parts.second);
      const remaining = 86400 - elapsed;
      const hours = Math.floor(remaining / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;
      countdown.querySelector("[data-zl-countdown-hours]").textContent = pad(hours);
      countdown.querySelector("[data-zl-countdown-minutes]").textContent = pad(minutes);
      countdown.querySelector("[data-zl-countdown-seconds]").textContent = pad(seconds);
      countdown.querySelector("[data-zl-countdown-time]").setAttribute(
        "datetime",
        `PT${hours}H${minutes}M${seconds}S`
      );
    };

    const initialize = (scope = document) => {
      const countdowns = scope.matches?.(selector)
        ? [scope]
        : [...scope.querySelectorAll(selector)];
      countdowns.forEach((countdown) => {
        if (countdown.dataset.zlCountdownReady) return;
        countdown.dataset.zlCountdownReady = "true";
        update(countdown);
        window.setInterval(() => update(countdown), 1000);
      });
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => initialize(), { once: true });
    } else {
      initialize();
    }

    document.addEventListener("shopify:section:load", (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
